import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { projects } from "../data/site";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const inputCls =
  "w-full bg-white border border-gray-300 px-4 py-3 text-sm text-ink placeholder:text-gray-400 focus:outline-none focus:border-navy focus:ring-1 focus:ring-navy transition-[border-color,box-shadow] duration-300";

export const EnquiryForm = ({ defaultProject = "General" }) => {
  const [form, setForm] = useState({
    name: "",
    phone: "",
    email: "",
    project: defaultProject,
    message: "",
  });
  const [sending, setSending] = useState(false);

  const set = (key) => (e) => setForm((f) => ({ ...f, [key]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await axios.post(`${API}/enquiries`, form);
      toast.success("Thank you — your enquiry has been received. We'll reach out shortly.");
      setForm({ name: "", phone: "", email: "", project: defaultProject, message: "" });
    } catch {
      toast.error("Something went wrong. Please try WhatsApp or call us instead.");
    } finally {
      setSending(false);
    }
  };

  return (
    <form data-testid="enquiry-form" onSubmit={submit} className="flex flex-col gap-5">
      <div className="grid sm:grid-cols-2 gap-5">
        <div>
          <label htmlFor="enquiry-name" className="block text-xs font-semibold uppercase tracking-[0.2em] text-gray-500 mb-2">Name</label>
          <input id="enquiry-name" data-testid="enquiry-name-input" required value={form.name} onChange={set("name")} placeholder="Your full name" className={inputCls} />
        </div>
        <div>
          <label htmlFor="enquiry-phone" className="block text-xs font-semibold uppercase tracking-[0.2em] text-gray-500 mb-2">Phone</label>
          <input id="enquiry-phone" data-testid="enquiry-phone-input" required type="tel" value={form.phone} onChange={set("phone")} placeholder="+91" className={inputCls} />
        </div>
      </div>
      <div>
        <label htmlFor="enquiry-email" className="block text-xs font-semibold uppercase tracking-[0.2em] text-gray-500 mb-2">Email</label>
        <input id="enquiry-email" data-testid="enquiry-email-input" required type="email" value={form.email} onChange={set("email")} placeholder="you@example.com" className={inputCls} />
      </div>
      <div>
        <label htmlFor="enquiry-project" className="block text-xs font-semibold uppercase tracking-[0.2em] text-gray-500 mb-2">Project of interest</label>
        <select id="enquiry-project" data-testid="enquiry-project-select" value={form.project} onChange={set("project")} className={inputCls}>
          <option value="General">General enquiry</option>
          {projects.map((p) => (
            <option key={p.slug} value={p.name}>{p.name}</option>
          ))}
        </select>
      </div>
      <div>
        <label htmlFor="enquiry-message" className="block text-xs font-semibold uppercase tracking-[0.2em] text-gray-500 mb-2">Message</label>
        <textarea id="enquiry-message" data-testid="enquiry-message-input" required rows={4} value={form.message} onChange={set("message")} placeholder="Tell us what you're looking for" className={`${inputCls} resize-none`} />
      </div>
      <button
        type="submit"
        data-testid="enquiry-submit-button"
        disabled={sending}
        className="mt-2 bg-brand text-white text-sm font-semibold px-8 py-4 transition-[transform,background-color,opacity] duration-300 hover:-translate-y-0.5 hover:bg-[#e0671a] disabled:opacity-60 disabled:hover:translate-y-0"
      >
        {sending ? "Sending…" : "Send enquiry"}
      </button>
    </form>
  );
};
